"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICOS_SALES_CENTER_COMPLIANCE_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.PICOS_SALES_CENTER_COMPLIANCE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment PicOSSalesCenterCompliance on PicOSSalesCenterCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    numStoresSurveyed\n  }\n"], ["\n  fragment PicOSSalesCenterCompliance on PicOSSalesCenterCompliance {\n    id\n    name\n    totalPriorities\n    numCompliant\n    rank\n    previousRank\n    numStoresSurveyed\n  }\n"])));
var templateObject_1;
